<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.name" :label="$t('delivery.branch.labels.name')" icon="store"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
              <show-field :value="item.isDefault ? item.isDefault.toString() : ''" :label="$t('delivery.branch.labels.isDefault')" icon="verified"/>

            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>

            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'


    export default {
        name: 'BranchShowData',
        components: {ShowField},

        props: {
            item: {type: Object, required: true}
        }
    }
</script>

